import { render, staticRenderFns } from "./IconSunOutline.vue?vue&type=template&id=0b828212"
import script from "./IconSunOutline.vue?vue&type=script&lang=js"
export * from "./IconSunOutline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports